import { RenderedRouteProps } from '../../../../types/route';
import { renderRoutes } from 'react-router-config';

function RootPage({ route }: RenderedRouteProps) {
  return renderRoutes(route.routes);
}

export default RootPage;
